module.exports = __webpack_public_path__ + "img/cuba-logo1.9a002142.png";